import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// api
import baseApi from "../../api/baseApi";

// diğer importlar
import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const toastConfig = {
  isLoading: false,
  autoClose: 5000,
  transition: Slide,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
};

const initialState = {
  loading: false,
  isUserLogout: false,

  isUserData: null,
  authCheckLoading: false,

  forgotPasswordLoading: false,
  sendVerifyCodeLoading: false,
  verifyCodeLoading: false,
  verifyPasswordCodeLoading: false,

  createCustomerLoading: false,
  createCompanyLoading: false,
  resetPasswordLoading: false,
};

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (userData) => {
    if (!userData) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const data = {
      ...userData,
      rememberMe: false,
      returnUrl: "",
    };

    try {
      const response = await baseApi.post(`/Auth/Login`, data);

      const responseData = {
        data: response.data.result,
        status: "success",
        token: response.data.result.accessToken,
      };

      localStorage.setItem("authUser", JSON.stringify(responseData));

      return responseData;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const logoutUser = () => async (dispatch) => {
  try {
    localStorage.removeItem("authUser");
    dispatch(logoutUserSuccess(true));
  } catch (error) {
    throw new Error(error);
  }
};

export const authCheck = createAsyncThunk(
  "auth/authCheck",
  async (_, { dispatch }) => {
    const user = localStorage.getItem("authUser");

    try {
      const response = await baseApi.get(`/Auth/AuthCheck`, {
        headers: {
          Authorization: `Bearer ${JSON.parse(user).token}`,
        },
      });

      return response.data.result;
    } catch (error) {
      localStorage.removeItem("authUser");
      dispatch(logoutUserSuccess(true));
      window.location.reload();

      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (phoneNumber) => {
    if (!phoneNumber) {
      const errMsg = "Telefon numarası bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const loadingToast = toast.loading("Lütfen bekleyin...");

    try {
      const response = await baseApi.post(
        `/Auth/SendPasswordCode?phoneNumber=${phoneNumber}`
      );

      toast.dismiss(loadingToast);

      return response.data.result;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: `Hata: ${errMsg}`,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const verifyPasswordCode = createAsyncThunk(
  "auth/verifyPasswordCode",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    try {
      const response = await baseApi.post(
        `/Auth/VerifyPasswordCode?phoneNumber=${values.phoneNumber}&code=${values.code}`
      );

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const sendVerifyCode = createAsyncThunk(
  "auth/sendVerifyCode",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    try {
      const response = await baseApi.post(
        `/Auth/SendVerificationCode?phoneNumber=${values.phoneNumber}&userType=${values.userType}&companyId=${values.companyId}`
      );

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    try {
      const response = await baseApi.post(
        `/Auth/ResetPassword?phoneNumber=${values.phoneNumber}`,
        { newPassword: values.newPassword }
      );

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const verifyCode = createAsyncThunk(
  "auth/verifyCode",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    try {
      const response = await baseApi.post(
        `/Auth/VerifyCode?phoneNumber=${values.phoneNumber}&code=${values.code}`
      );

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const createCustomer = createAsyncThunk(
  "auth/createCustomer",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const data = {
      firstName: values.firstName,
      lastName: values.lastName,
      phoneNumber: values.phoneNumber,
      plateNumber: values.plateNumber,
      email: values.email,
      companyId: values.companyId,
    };

    const loadingToast = toast.loading("Kaydediliyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.post(`/Auth/CreateCustomer`, data);

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const createCompany = createAsyncThunk(
  "auth/createCompany",
  async (values) => {
    if (!values) {
      const errMsg = "Veri bulunamadı!";

      toast.error(errMsg, {
        ...toastConfig,
      });

      throw new Error(errMsg);
    }

    const data = {
      companyName: values.companyName,
      companyTableName: values.companyTableName,
      authName: values.authName,
      authSurname: values.authSurname,
      companyType: parseInt(values.companyType),
      taxOffice: values.taxOffice,
      taxNumber: values.taxNumber,
      city: values.city,
      state: values.state,
      address: values.address,
      phoneNumber: values.phoneNumber,
      email: values.email,
      primAmount: 0,
      commissionFee: 0,
      primTriggerPercent: 0,
    };

    const loadingToast = toast.loading("Kaydediliyor...", {
      transition: Slide,
    });

    try {
      const response = await baseApi.post(`/Auth/CreateCompany`, data);

      toast.update(loadingToast, {
        render: "İşlem Tamamlandı.",
        type: "success",
        isLoading: false,
        autoClose: 5000,
        transition: Slide,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      });

      return response.data;
    } catch (error) {
      const errMsg =
        error?.response?.data?.errorMessage || "Genel bir hata oluştu!";

      toast.update(loadingToast, {
        render: errMsg,
        type: "error",
        ...toastConfig,
      });

      throw new Error(errMsg);
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    logoutUserSuccess(state) {
      state.isUserLogout = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(loginUser.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(loginUser.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(authCheck.pending, (state, action) => {
        state.isUserData = null;
        state.authCheckLoading = true;
      })
      .addCase(authCheck.fulfilled, (state, action) => {
        state.isUserData = action.payload;
        state.authCheckLoading = false;
      })
      .addCase(authCheck.rejected, (state, action) => {
        state.isUserData = null;
        state.authCheckLoading = false;
      });

    builder
      .addCase(forgotPassword.pending, (state, action) => {
        state.forgotPasswordLoading = true;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.forgotPasswordLoading = false;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.forgotPasswordLoading = false;
      });

    builder
      .addCase(sendVerifyCode.pending, (state, action) => {
        state.sendVerifyCodeLoading = true;
      })
      .addCase(sendVerifyCode.fulfilled, (state, action) => {
        state.sendVerifyCodeLoading = false;
      })
      .addCase(sendVerifyCode.rejected, (state, action) => {
        state.sendVerifyCodeLoading = false;
      });

    builder
      .addCase(verifyCode.pending, (state, action) => {
        state.verifyCodeLoading = true;
      })
      .addCase(verifyCode.fulfilled, (state, action) => {
        state.verifyCodeLoading = false;
      })
      .addCase(verifyCode.rejected, (state, action) => {
        state.verifyCodeLoading = false;
      });

    builder
      .addCase(verifyPasswordCode.pending, (state, action) => {
        state.verifyPasswordCodeLoading = true;
      })
      .addCase(verifyPasswordCode.fulfilled, (state, action) => {
        state.verifyPasswordCodeLoading = false;
      })
      .addCase(verifyPasswordCode.rejected, (state, action) => {
        state.verifyPasswordCodeLoading = false;
      });

    builder
      .addCase(resetPassword.pending, (state, action) => {
        state.resetPasswordLoading = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.resetPasswordLoading = false;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.resetPasswordLoading = false;
      });

    builder
      .addCase(createCustomer.pending, (state, action) => {
        state.createCustomerLoading = true;
      })
      .addCase(createCustomer.fulfilled, (state, action) => {
        state.createCustomerLoading = false;
      })
      .addCase(createCustomer.rejected, (state, action) => {
        state.createCustomerLoading = false;
      });

    builder
      .addCase(createCompany.pending, (state, action) => {
        state.createCompanyLoading = true;
      })
      .addCase(createCompany.fulfilled, (state, action) => {
        state.createCompanyLoading = false;
      })
      .addCase(createCompany.rejected, (state, action) => {
        state.createCompanyLoading = false;
      });
  },
});

export const { logoutUserSuccess } = authSlice.actions;

export default authSlice.reducer;
